import { TypedFormConfig } from '@shopee/use-form-hook';
import { TypedFormData } from '@shopee/use-form-hook/src/hooks/useTypedForm/types';
import { OneCredentialDelinkSetPasswordFormShape } from '@shopee-user/business-customization-types';
import { strongPassword } from '@shopee/validators';

const confirmPasswordValidator = (errMsg: string) => {
  return (
    val: string,
    formData: TypedFormData<OneCredentialDelinkSetPasswordFormShape>
  ) => {
    return val !== formData.newPassword ? errMsg : '';
  };
};

export const ONE_CREDENTIAL_DELINK_SET_PASSWORD_FORM_CONFIG: TypedFormConfig<OneCredentialDelinkSetPasswordFormShape> = {
  newPassword: {
    type: 'string',
    initialValue: '',
    validators: [
      strongPassword('label_one_credential_delink_password_is_weak'),
    ],
  },
  newPasswordRepeat: {
    type: 'string',
    initialValue: '',
    validators: [
      confirmPasswordValidator('label_one_credential_delink_password_mismatch'),
    ],
  },
};
